module.exports = __webpack_public_path__ + "img/drag-handle.279a5e01.svg";